import React from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import DashboardHome from '../pages/DashboardHome';
import StudentModule from '../pages/StudentModule';
import AdminModule from '../pages/AdminModule';

function Sidebar({ onLogout }) {
  const links = [
    { to: '/dashboard', label: '📊 Dashboard' },
    { to: '/dashboard/students', label: '👨‍🎓 Students & Profiles' },
    { to: '/dashboard/attendance', label: '📅 Attendance Tracking' },
    { to: '/dashboard/timetable', label: '📆 Class Timetable' },
    { to: '/dashboard/grades', label: '📈 Grades & Reports' },
    { to: '/dashboard/fees', label: '💰 Fee Management' },
    { to: '/dashboard/messages', label: '💬 Message Center' },
    { to: '/dashboard/certificates', label: '🎖️ ID & Certificates' },
    { to: '/dashboard/pre-admission', label: '📝 Pre-Admission' },
    { to: '/dashboard/leave', label: '🏖️ Leave Management' },
    { to: '/dashboard/feedback', label: '📝 Feedback' },
    { to: '/dashboard/projects-seminars', label: '🎓 Projects & Seminars' },
    { to: '/dashboard/gallery', label: '🖼️ Gallery' },
  ];

  return (
    <aside className="dash-sidebar">
      <div className="dash-brand">🏫 Institute Portal</div>
      <nav className="dash-nav">
        {links.map(l => (
          <NavLink key={l.to} to={l.to} className={({isActive}) => `nav-link ${isActive ? 'active' : ''}`}>
            {l.label}
          </NavLink>
        ))}
        <button className="nav-link logout" onClick={onLogout}>🚪 Logout</button>
      </nav>
    </aside>
  );
}

function Header({ user }) {
  return (
    <header className="dash-header">
      <div className="dash-user">
        <span className="user-role">{user.role.toUpperCase()}</span>
        <span className="user-name">{user.name}</span>
      </div>
      <div className="dash-academic">📅 Academic Year: {user.academicYear}</div>
    </header>
  );
}

export default function DashboardLayout({ user, onLogout }) {
  return (
    <div className="dashboard-wrapper">
      <Sidebar onLogout={onLogout} />
      <div className="dash-main">
        <Header user={user} />
        <main className="dash-content">
          <Routes>
            <Route path="/" element={<DashboardHome />} />
            <Route path="/students/*" element={<StudentModule module="profile" />} />
            <Route path="/attendance" element={<StudentModule module="attendance" />} />
            <Route path="/timetable" element={<StudentModule module="timetable" />} />
            <Route path="/grades" element={<StudentModule module="grades" />} />
            <Route path="/fees" element={<AdminModule module="fees" />} />
            <Route path="/messages" element={<AdminModule module="messages" />} />
            <Route path="/certificates" element={<AdminModule module="certificates" />} />
            <Route path="/pre-admission" element={<AdminModule module="pre-admission" />} />
            <Route path="/leave" element={<AdminModule module="leave" />} />
            <Route path="/feedback" element={<AdminModule module="feedback" />} />
            <Route path="/projects-seminars" element={<AdminModule module="projects-seminars" />} />
            <Route path="/gallery" element={<AdminModule module="gallery" />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}